import { CDNImage } from '~/components/ui/CDNImage'

export function DeepseekSilent() {
  return (
    <div className="flex flex-col items-center justify-center  gap-2 mb-6">
      <CDNImage
        alt="DeepSeek"
        src="/images/deepseek/brain.svg"
        className="w-20 h-20 block mx-auto"
      />
      <div className="text-[32px] leading-[40px] font-semibold text-neutral-900">
        欢迎使用DeepSeek-R1 (671B满血版)
      </div>
      <div className="text-neutral-500 text-sm font-semibold">
        此模型擅长数学、代码及自然语言推理任务，支持深度思考，可以帮你写作各种创意内容，请把你的任务交给我吧~
      </div>
    </div>
  )
}
